import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "install_prompt_dismissed";

// Nudges the user to add the app to their home screen (Android/Chrome shows a
// real install prompt; iOS Safari gets the Share -> Add to Home Screen hint).
export const InstallPrompt = () => {
  const [event, setEvent] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY)) return;
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setEvent(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIOS) setShow(true);

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const close = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (!event) return;
    event.prompt();
    await event.userChoice;
    close();
  };

  if (!show) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-zinc-950 bg-zinc-950 px-4 py-3 text-white md:hidden"
    >
      <div className="flex items-center gap-3">
        <div className="min-w-0 flex-1">
          <p className="text-sm font-bold">Add to home screen</p>
          <p className="mt-0.5 text-xs text-zinc-400">
            {event
              ? "Open the app in one tap, just like a normal app."
              : "Tap Share in Safari, then “Add to Home Screen”."}
          </p>
        </div>
        {event && (
          <Button
            data-testid="install-app-button"
            size="sm"
            className="shrink-0 rounded-sm bg-[#C8A03C] text-zinc-950 hover:bg-[#b08d31]"
            onClick={install}
          >
            <Download size={14} className="mr-1.5" /> Install
          </Button>
        )}
        <button data-testid="install-dismiss-button" onClick={close} aria-label="Dismiss" className="shrink-0 p-1 text-zinc-400">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
